import React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

// Custom styled switch with improved visual cues and mobile-friendly touch targets
export const EnhancedSwitch = styled(Switch)(({ theme }) => ({
  width: 48, // Wider for better touch target
  height: 26, // Taller for better touch target
  padding: 0,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(4px)',
    '&.Mui-checked': {
      transform: 'translateX(22px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 0.85,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 20,
    height: 20,
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    border: '1px solid #ccc',
    backgroundColor: 'rgba(0,0,0,0.15)',
    opacity: 1,
    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.1)',
    transition: theme.transitions.create(['background-color']),
  },
}));

// Enhanced FormControlLabel with better visual styling and mobile-friendly touch target
export const EnhancedFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    fontSize: '0.875rem',
    '@media (max-width: 600px)': {
      fontSize: '0.8rem',
    },
  },
  backgroundColor: 'rgba(0, 0, 0, 0.05)',
  borderRadius: '20px',
  padding: '4px 12px',
  margin: '4px 8px 4px 0',
  minHeight: '44px', // Mobile-friendly minimum touch target height
  display: 'inline-flex',
  alignItems: 'center',
  transition: 'all 0.2s ease',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.09)',
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
  },
}));

// Component that combines both styled elements
export const EnhancedToggle = ({ checked, onChange, label, size = 'small', ...props }) => {
  return (
    <EnhancedFormControlLabel
      control={
        <EnhancedSwitch
          checked={checked}
          onChange={onChange}
          size={size}
          {...props}
        />
      }
      label={label}
    />
  );
};

export default EnhancedToggle;
